export class NeoGarantiaIntermediarioDTO {
  constructor(
    public nombre:String,
    public idParametrizacionCondicion: Number,
    public estado:String,
    public idCliente: Number,
    public idUsuario: Number,
    public  justificacion:String
  ) {}
}
